import { get } from '@aiptyg/api-client';
import type {
  WithdrawalStatisticsRange,
  WithdrawalStatisticsResponseDTO,
} from '../types/withdrawal-statistics.types';

export interface WithdrawalStatisticsParams {
  range: WithdrawalStatisticsRange;
  startDate: string;
  endDate: string;
  channel: string;
}

export function getWithdrawalStatistics(
  params: WithdrawalStatisticsParams,
): Promise<WithdrawalStatisticsResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('range', params.range);
  if (params.range === 'custom') {
    qs.set('start_date', params.startDate);
    qs.set('end_date', params.endDate);
  }
  if (params.channel) qs.set('channel', params.channel);
  return get<WithdrawalStatisticsResponseDTO>(`/v1/admin/withdrawals/statistics?${qs.toString()}`);
}
